import GLU from '../glu2.js/src/index';

class ReportApi extends GLU.Api {
  constructor(endpoint) {
    super(endpoint);

    this.createApiActions(
      {
        name: 'getGeosByFipsCodes',
        method: GLU.Api.Post,
        path: '/GetGeoItemsByFipsCodes',
        credentials: true,
      },
      {
        name: 'getSystemReports',
        method: GLU.Api.Get,
        path: '/GetSystemReports',
        credentials: true,
      },
      {
        name: 'getCpiValues',
        method: GLU.Api.Get,
        path: '/GetConsumerPriceIndices',
        credentials: true,
      },
    );
  }
}

export default ReportApi;
